import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { MyLearningOnDemandTabs, ON_DEMAND_TAB_PATHS } from 'src/pages/MyLearningPage/children/MyLearningOnDemandTabs';
import { useAtlassianUser } from 'src/hooks/useAtlassianUser';
import { LiveTrainingNotice } from 'src/pages/MyLearningPage/children/LiveTrainingNotice';

export const MyLearningPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isLoading: isLoadingAtlassianUser } = useAtlassianUser();

  const activeTabIndex = ON_DEMAND_TAB_PATHS.findIndex((path) => location.pathname.includes(path));

  useEffect(() => {
    if (activeTabIndex === -1 || (!isLoadingAtlassianUser && !user)) {
      navigate(`/not-found`);
    }
  }, [activeTabIndex, isLoadingAtlassianUser, navigate, user]);

  return (
    <>
      <LiveTrainingNotice />
      <MyLearningOnDemandTabs activeTabIndex={activeTabIndex} />
    </>
  );
};
